import { EventSoundtrack } from "../redux/features/event/event.types";

export type SoundtrackProvider = "spotify" | "soundcloud";

export const getSoundtrackProvider = (
  url?: string,
): SoundtrackProvider | undefined => {
  if (!url) return undefined;

  try {
    const parsedUrl = new URL(url);
    const hostname = parsedUrl.hostname.replace(/^www\./, "");

    if (
      hostname === "open.spotify.com" &&
      parsedUrl.pathname.startsWith("/track/")
    ) {
      return "spotify";
    }

    if (
      hostname === "soundcloud.com" &&
      parsedUrl.pathname.split("/").filter(Boolean).length >= 2
    ) {
      return "soundcloud";
    }
  } catch {
    return undefined;
  }

  return undefined;
};

export const isSupportedSoundtrackUrl = (url?: string) => {
  if (!url) return true;
  return getSoundtrackProvider(url) !== undefined;
};

export const getSpotifyTrackId = (url?: string) => {
  if (!url || getSoundtrackProvider(url) !== "spotify") return undefined;

  try {
    return new URL(url).pathname.split("/").filter(Boolean)[1];
  } catch {
    return undefined;
  }
};

export const getSpotifyUri = (soundtrack?: EventSoundtrack) => {
  if (!soundtrack || soundtrack.provider !== "spotify") return undefined;
  const trackId = soundtrack.externalId || getSpotifyTrackId(soundtrack.url);
  return trackId ? `spotify:track:${trackId}` : undefined;
};

export const getSoundtrackEmbedUrl = (soundtrack?: EventSoundtrack) => {
  if (!soundtrack?.url) return undefined;

  if (soundtrack.embedUrl) return soundtrack.embedUrl;

  if (soundtrack.provider === "spotify") {
    const trackId = soundtrack.externalId || getSpotifyTrackId(soundtrack.url);
    return trackId ? `https://open.spotify.com/embed/track/${trackId}` : "";
  }

  if (soundtrack.provider === "soundcloud") {
    return `https://w.soundcloud.com/player/?url=${encodeURIComponent(
      soundtrack.url,
    )}&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&visual=false`;
  }

  return undefined;
};

export const getSoundtrackDisplayTitle = (soundtrack?: EventSoundtrack) => {
  if (!soundtrack) return "";
  return [soundtrack.title, soundtrack.artist].filter(Boolean).join(" · ");
};
